module.exports = __webpack_public_path__ + "static/shifts-card-2-d9b7a933b7ba11f52c35ef70b2345997.png";